export const removeNullValues = (data) =>
  data &&
  Object?.keys(data)?.reduce((prev, curr) => {
    if (data[curr] === null || data[curr] === undefined) {
      data[curr] = '';
    }
    return data;
  }, {});
